import React from 'react';
import {
  Box,
  TextField,
  InputAdornment,
  Paper,
  Chip,
  Stack,
} from '@mui/material';
import { Search, Clear } from '@mui/icons-material';

const UniversitySearch = ({ 
  searchTerm, 
  onSearchChange, 
  onClearSearch,
  popularSearches = ['医学', '工程', '商科', '计算机', '吉隆坡'],
  resultCount 
}) => {
  const handleSearchChange = (event) => {
    onSearchChange(event.target.value);
  };

  const handlePopularSearch = (term) => {
    onSearchChange(term);
  };

  const handleClearSearch = () => {
    onSearchChange('');
    if (onClearSearch) onClearSearch();
  };

  return (
    <Paper 
      elevation={2} 
      sx={{ 
        p: 3, 
        mb: 3,
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        borderRadius: 2
      }}
    >
      <Box sx={{ mb: 2 }}>
        <TextField
          fullWidth
          placeholder="搜索大学名称"
          value={searchTerm}
          onChange={handleSearchChange}
          variant="outlined"
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
              borderRadius: 2,
              '&:hover': {
                backgroundColor: 'white',
              },
              '&.Mui-focused': {
                backgroundColor: 'white',
              }
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search color="action" />
              </InputAdornment>
            ),
            endAdornment: searchTerm && (
              <InputAdornment position="end">
                <Clear 
                  sx={{ cursor: 'pointer', color: 'action.active' }}
                  onClick={handleClearSearch}
                />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {/* 搜索结果数量 */}
      {resultCount !== undefined && (
        <Box sx={{ mb: 2 }}>
          <Box component="span" sx={{ color: 'text.secondary', fontSize: '0.9rem' }}>
            找到 <strong>{resultCount}</strong> 所大学
            {searchTerm && (
              <>
                {' '}关于 "<strong>{searchTerm}</strong>"
              </>
            )}
          </Box>
        </Box>
      )}

      {/* 热门搜索 */}
      {!searchTerm && (
        <Box>
          <Box sx={{ mb: 1, color: 'text.secondary', fontSize: '0.9rem' }}>
            热门搜索：
          </Box>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {popularSearches.map((term, index) => (
              <Chip
                key={index}
                label={term}
                variant="outlined"
                size="small"
                clickable
                onClick={() => handlePopularSearch(term)}
                sx={{
                  '&:hover': {
                    backgroundColor: 'primary.main',
                    color: 'white',
                    borderColor: 'primary.main',
                  }
                }}
              />
            ))}
          </Stack>
        </Box>
      )}
    </Paper>
  );
};

export default UniversitySearch;